import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { postDemoRequest } from '@/lib/api';

export default function FinalCtaSection() {
  const [form, setForm] = useState({ full_name: '', work_email: '', company: '', monthly_ad_spend: '', message: '' });
  const [status, setStatus] = useState('idle');
  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    try {
      await postDemoRequest({ ...form, source: 'home-cta' });
      setStatus('done');
      setForm({ full_name: '', work_email: '', company: '', monthly_ad_spend: '', message: '' });
    } catch (err) {
      setStatus('error');
    }
  };

  return (
    <section className="highlights-section" id="final-cta" data-testid="final-cta-section">
      <div className="highlights-glow highlights-glow-one" />
      <div className="highlights-glow highlights-glow-two" />
      <div className="container-r360">
        <div className="highlights-kicker">
          <span />STOP WASTING AD BUDGET
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 xl:gap-10 md:gap-6 items-start">
          <div className="lg:col-span-6">
            <h2 className="reveal-on-scroll lg:col-span-7 font-display text-[3.25rem] sm:text-[4.5rem] xl:text-[5.75rem] font-bold leading-[0.92] tracking-[-0.03em] text-[#262626]">
              Stop Paying For<br /> <span className="accent">Clicks.</span> Pay For <br /> <span className="text-[#60a5fa]">Sales.</span>
            </h2>
            <p className="sec-subhead leading-relaxed mt-6 max-w-lg">
              Every day you run CPM retargeting you pay for impressions with zero guarantee of return. Switch to Retarget360.ai and align every dollar with a verified revenue event.
            </p>
            <div className="mt-6 highlight-card">
              <div className="font-extrabold font-display text-[#262626] mb-2">PERFORMANCE GUARANTEE</div>
              <p className="sec-subhead leading-relaxed">
                If we don't deliver measurable ROAS lift within 60 days, you pay nothing — and we'll run your next month's campaign at zero cost to prove it.
              </p>
            </div>
     
          </div>

          <form onSubmit={submit} className="lg:col-span-6 border mt-6 lg:mt-0 border-[#1a1a1a] bg-white/70 p-5 md:p-8 xl:p-12 reveal-on-scroll" data-testid="home-cta-form">
            <div className="font-sans text-[28px] md:text-[32px] font-bold mb-8">BOOK A STRATEGY CALL</div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div>
                <label className="field-label">FULL NAME *</label>
                <input required className="field-input" value={form.full_name} onChange={onChange('full_name')} data-testid="cta-fullname" />
              </div>
              <div>
                <label className="field-label">WORK EMAIL *</label>
                <input required type="email" className="field-input" value={form.work_email} onChange={onChange('work_email')} data-testid="cta-email" />
              </div>
              <div>
                <label className="field-label">COMPANY *</label>
                <input required className="field-input" value={form.company} onChange={onChange('company')} data-testid="cta-company" />
              </div>
              <div>
                <label className="field-label">MONTHLY AD SPEND</label>
                <input className="field-input" placeholder="$50K — $250K" value={form.monthly_ad_spend} onChange={onChange('monthly_ad_spend')} data-testid="cta-spend" />
              </div>
              <div className="sm:col-span-2">
                <label className="field-label">WHAT ARE YOU TRYING TO SOLVE?</label>
                <textarea className="field-textarea" rows={2} value={form.message} onChange={onChange('message')} data-testid="cta-message" />
              </div>
            </div>
            <div className="flex flex-wrap gap-4 mt-10 items-center">
              <button type="submit" disabled={status === 'loading'} className="btn btn-primary disabled:opacity-60" data-testid="cta-submit">
                {status === 'loading' ? 'Sending…' : 'Book the call →'}
              </button>
              <Link to="/book-a-demo" className="btn btn-outline-alt">
                Full demo form →
              </Link>
            </div>
            {status === 'done' && <div className="text-[#22d07a] mt-6 font-mono text-[13px]" data-testid="cta-success">✓ REQUEST RECEIVED — WE REPLY WITHIN 24H.</div>}
            {status === 'error' && <div className="text-red-500 mt-6 font-mono text-[13px]">✗ SOMETHING WENT WRONG. TRY AGAIN.</div>}
            <div className="mono-label text-[#5a5a5a] mt-6">WE REPLY WITHIN 24H · NDA AVAILABLE ON REQUEST</div>
          </form>
        </div>
      </div>
    </section>
  );
}
